import { CdsInputField, useFormContext } from "clayco-component-library/lib";
import React, { useEffect, useState } from "react";
import {Row, Col} from 'react-bootstrap';

const NameModalForm = ({model}) => {
    const {setValue} = useFormContext();
    const [pending, setPending] = useState(model?.pending);
    const [record, setRecord] = useState(model?.record);
    const [admin, setAdmin] = useState(model?.admin);

    useEffect(()=> {
        // use model info and call setValue
        if (!model || model === undefined)
            return;
    }, []);



    const onFieldChange = (value, field) => {
        setValue(field, value);
    };

    return(
        <>
        <div className="name-review-Modal">
            <Row>
                <Col md={8}>
                    <CdsInputField
                        initialValue={admin?.legalFirstName ?? pending?.legalFirstName ?? record.legalFirstName}
                        label={'Legal First Name'}
                        required={true}
                        name='legalFirstName'
                        onChange={(value)=> onFieldChange(value, 'legalFirstName')}
                        allowMultiple={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={8}>
                    <CdsInputField
                        initialValue={admin?.legalLastName ?? pending?.legalLastName ?? record.legalLastName}
                        label={'Legal Last Name'}
                        required={true}
                        name='legalLastName'
                        onChange={(value)=> onFieldChange(value, 'legalLastName')}
                        allowMultiple={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={8}>
                    <CdsInputField
                        initialValue={admin?.preferredName ?? pending?.preferredName ?? record.preferredName}
                        label={'Nickname/Preferred First Name'}
                        required={false}
                        name='preferredName'
                        onChange={(value)=> onFieldChange(value, 'preferredName')}
                        allowMultiple={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={8}>
                    <CdsInputField
                        initialValue={admin?.presentationName ?? pending?.presentationName ?? record.presentationName}
                        label={'Presentation Name (Email Signature)'}
                        required={false}
                        name='presentationName'
                        onChange={(value) => onFieldChange(value, 'presentationName')}
                        allowMultiple={false}
                    />
                </Col>
            </Row>
        </div>
        </>
    )
};

export default NameModalForm;